export const BOOKING_TYPES_SELECTION_STORAGE_KEY = 'booking-types-selection'
export const BOOKING_TYPES_VIEW_STORAGE_KEY = 'booking-types-view'

export const DEFAULT_BOOKING_TYPES_VIEW = {
  colorfulIcons: true,
  showIcons: true,
}
